import { render, staticRenderFns } from "./CustomizeMetalAV.vue?vue&type=template&id=6e3afd4e&scoped=true"
import script from "./CustomizeMetalAV.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAV.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAV.vue?vue&type=style&index=0&id=6e3afd4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3afd4e",
  null
  
)

export default component.exports